import React, { useEffect, useState } from 'react'
import { ProductsCarouselProps } from './types'
import './index.scss'

// Extending the Window interface to include the createCard property
declare global {
  interface Window {
    createCard?: (element: ProductCardType, options?: object) => string
  }
}

import { ProductCardType } from '@petz/ds-card/dist/ProductCard/types'
import { ProductCardWrapper } from '@/Components/ProductCardWrapper'
import { CarouselWrapper } from '@/Components/CarouselWrapper'
import { fetchProducts } from '@/Requests/getProducts'

import { createProductsArrayForSkeleton } from '@/Utils/generateProductForSkeleton'

const createProductsSkeleton = (size: string) => createProductsArrayForSkeleton(size == 'full' ? 6 : 3)

export const ProductsCarousel: React.FC<ProductsCarouselProps> = ({ id, urls, size }) => {
  const [products, setProducts] = useState<ProductCardType[]>([])
  const [showSkeleton, setShowSkeleton] = useState(true)
  let interval: NodeJS.Timeout

  useEffect(() => {
    fetchProducts(...urls).then((data) => {
      setProducts(data)
    })
  }, [urls])

  function queryInterval() {
    interval = setInterval(function () {
      const elements = document.querySelectorAll(`#${id} ptz-card-price-section p`)

      if (elements.length == products.length) {
        setShowSkeleton(false)
      } else {
        interval = queryInterval()
      }
    }, 100)

    return interval
  }

  useEffect(() => {
    if (products.length === 0) return

    if (window.createCard == null) {
      setShowSkeleton(false)
    } else {
      interval = queryInterval()
    }
  }, [products])

  const cardSize = window?.innerWidth < 768 ? 'lg' : 'md'

  const productsSkeleton = () => (
    <CarouselWrapper id={id} size={size}>
      {createProductsSkeleton(size).map((element, index) => (
        <ProductCardWrapper size={cardSize} key={index} data={element} skeleton={true} />
      ))}
    </CarouselWrapper>
  )

  const preloadImage = (url: string) => {
    const img = new Image()
    img.src = url
  }

  const renderCards = () => {
    if (window?.createCard != null) {
      return products.map((element) => {
        preloadImage(element.thumbnail)
        const productCardString = window?.createCard ? window?.createCard(element, { size: cardSize }) : ''
        return <div className="monolith-card" key={element.id} dangerouslySetInnerHTML={{ __html: productCardString }} />
      })
    } else {
      return products.map((element) => <ProductCardWrapper size={cardSize} key={element.sku} data={element} />)
    }
  }

  return (
    <div className={`products-carousel ${showSkeleton ? 'skeleton' : ''}`}>
      <div className="skeleton-carousel">{productsSkeleton()}</div>
      <div className="products-carousel">
        <CarouselWrapper id={id} size={size}>
          {renderCards()}
        </CarouselWrapper>
      </div>
    </div>
  )
}
